/**
 * Created by eliorc on 1/10/16.
 */

/*
 * this is the Chat bubble for the secure forms submission.
 * the chat bubble is dynamic and incharge of the display of the iframe containing the data of the bubble.
 *
 * the bubble should only show the iframe if the chat is active and the getOTK is success.
 * in case of an inactive session or an error in the OTK request the view will display proper error messages.
 *
 * */
define(function (require) {

    var lpUtils = require('utils/lpUtils');
    var WebAgentLogger = require('web-agent-assets-js/WebAgentLogger');
    var agentLEManager = require('web-agent-utils/agentLEManager');
    var lpSecureFormsController = require('web-agent-assets-js/lpSecureFormsController');
    var ViewController = require('web-agent-framework/ViewController');

    var LOADING_TIMEOUT = 1000 * 30; // 30SEC
    var PCI_RESULTS_PAGE = '/pcigw/pci_dynamic_results_le.jsp';
    var PCI_STATUS_RESPONSES = {
        OK: 'ok',
        ERROR: 'error'
    };
    var ERRORS = {
        FORM_CALCULATION: 'PCI GW Failed to calculate container height',
        PCI_GW_ERROR: 'PCI GW return error.',
        PCI_GW_DATA_ERROR: 'PCI GW data internal error.'
    };
    var MIN_BUBBLE_HEIGHT = 50;
    var BUBBLE_PADDING = 35;
    var TOKENIZER_DOMAIN_KEY = '{tokenizer}';
    var applicationType = 'SecureFormChatBubbleViewController';
    var logger = WebAgentLogger.getLogger(applicationType);


    var SecureFormChatBubbleViewController = ViewController.extend({
        ControllerName: "SecureFormChatBubbleViewController",
        applicationType: 'SecureFormChatBubbleViewController',
        templateFile: 'LP_secure_form_chat_bubble.html',

        LPViewMap: {
            wrapper: '.lpview_secure_form_bubble',
            stateWrapper: '.lpview_state_placeholder',
            iFrame: '.lpview_iframe_placeholder',
            refreshAction: '.lpview_refresh_action',
            displayAction: '.lpview_secure_forms_init_state_display_button',
            secureFormHeader: '.lpview_secure_form_header',
            secureFormBody: '.lpview_secure_form_body',
            secureFormTitle: '.lpview_secure_form_title',
            initStateFormName: '.lpview_secure_forms_init_state_text_form_name',
            errorText: '.lpview_error_message_text'

        },

        LPStateMaps: {
            init: 'init',
            loading: 'loading',
            error: 'error',
            success: 'success'
        },

        initialize: function (constructorData) {
            this.secureFormUniqueId = constructorData.secureFormUniqueId;
            this.secureFormData = lpTag.WebAgent.secureFormsController.getSecureFormData(this.secureFormUniqueId);
            this.modelController = constructorData.modelController;
            this.tokenServerDomain = _getSourceOrigin();
            this.iframeElement = this.getFirstElement(this.LPViewMap.iFrame, this);
            this.onDisplayResolved = constructorData.onDisplayResolved;
            this.chatsRootModelPath = constructorData.chatsRootModelPath;
            this.asyncMessaging = constructorData.asyncMessaging;

            this.onIFrameLoaded = _onIFrameLoaded.bind(this);
            this.onIFrameError = _onIFrameError.bind(this);
            this.onIFrameTimeOut = _onIFrameTimeOut.bind(this);

            this.initView();
        },
        events: function () {
            this.bindViewEvent({
                selector: this.LPViewMap.refreshAction,
                DOMEvent: "click",
                callback: this.initIFrameView
            });

            this.bindViewEvent({
                selector: this.LPViewMap.displayAction,
                DOMEvent: "click",
                callback: this.initIFrameView
            });
        },
        render: function () {

        }
    });


    SecureFormChatBubbleViewController.prototype.fireDisplayResolved = function () {
        if (this.onDisplayResolved) {
            this.onDisplayResolved();
        }
    };

    SecureFormChatBubbleViewController.prototype.setBindings = function () {
        this.bindViewEvent({view: window, DOMEvent: "message", callback: this.onPostMessageReceived});
        lpUtils.addEventListener(this.iframeElement, 'load', this.onIFrameLoaded);
        lpUtils.addEventListener(this.iframeElement, 'error', this.onIFrameError);
    };

    SecureFormChatBubbleViewController.prototype.removeBindings = function () {
        this.unbindViewEvent({view: window, DOMEvent: "message", callback: this.onPostMessageReceived});
        lpUtils.removeEventListener(this.iframeElement, 'load', this.onIFrameLoaded);
        lpUtils.removeEventListener(this.iframeElement, 'error', this.onIFrameError);
        this.removeTimeout();
    };

    SecureFormChatBubbleViewController.prototype.removeTimeout = function () {
        if (this.iframeLoadingTimeout) {
            clearTimeout(this.iframeLoadingTimeout);
            this.iframeLoadingTimeout = null;
        }
    };

    SecureFormChatBubbleViewController.prototype.setState = function (state, message) {
        var wrapper = this.getFirstElement(this.LPViewMap.wrapper);
        var stateClasses = [this.LPStateMaps.success, this.LPStateMaps.loading, this.LPStateMaps.error, this.LPStateMaps.init];
        var stateIndex = stateClasses.indexOf(state);
        if (stateIndex >= 0) {
            stateClasses.splice(stateIndex, 1);
        }

        // reporting error to the server.
        if (state === this.LPStateMaps.error) {
            this.handleErrorState(message);
        }

        this.removeClass(wrapper, stateClasses);
        this.addClass(wrapper, state);

        if (state === this.LPStateMaps.error || state === this.LPStateMaps.success) {
            this.fireDisplayResolved();
        }
    };

    SecureFormChatBubbleViewController.prototype.setErrorMessage = function (errorMessage) {
        var errorMessageElm = this.getFirstElement(this.LPViewMap.errorText);
        if (errorMessageElm) {
            errorMessageElm.innerHTML = errorMessage;
        }
    };

    SecureFormChatBubbleViewController.prototype.handleErrorState = function (errorMessage) {
        if (!lpTag.WebAgent.logicController.isActiveChat(this.secureFormData.chatId) && !lpTag.WebAgent.logicController.hasSecureFormsViewPermissionForHistory()) {
            //if the user doesn't have history permissions
            //hide the refresh action
            this.addClass(this.LPViewMap.refreshAction, "hide");
            this.setErrorMessage(this.translate('secure_forms_history_errorMessage'));
        }
        else if (errorMessage === ERRORS.FORM_CALCULATION) {
            // change to the form Calculation.
            this.setErrorMessage(this.translate('secure_forms_iframe_errorMessage_form_calculation'));
        } else {
            // Default to the original error message.
            this.setErrorMessage(this.translate('secure_forms_iframe_errorMessage'));
        }

        var mainDialog = lpTag.WebAgent.logicController.getMainDialogOfConversation(this.secureFormData.chatId, this.chatsRootModelPath); //since secure form has to be part of the main dialog
        lpTag.WebAgent.secureFormsController.reportEvent({
            command: lpSecureFormsController.EVENT_TYPES.ERROR,
            chatId: this.secureFormData.chatId,
            dialogId: mainDialog && mainDialog.dialogId,
            visitorId: this.secureFormData.visitorId,
            args: {
                uniqueId: this.secureFormData.uniqueId,
                secureFormId: this.secureFormData.secureFormId,
                secureFormName: this.secureFormData.secureFormName,
                errorReason: errorMessage,
                failedCommand: lpSecureFormsController.EVENT_TYPES.VIEWED
            }
        });
    };

    SecureFormChatBubbleViewController.prototype.initView = function () {
        // setting the name of the form in the placeholders.
        this.setFormName();
        this.setState(this.LPStateMaps.init);
    };

    SecureFormChatBubbleViewController.prototype.setFormName = function () {
        setElementText(this.getFirstElement(this.LPViewMap.initStateFormName), this.secureFormData.secureFormName);
        setElementText(this.getFirstElement(this.LPViewMap.secureFormTitle), this.secureFormData.secureFormName);

        function setElementText(elm, text) {
            if (elm) {
                elm.innerText = text;
                elm.textContent = text;
            }
        }
    };
    SecureFormChatBubbleViewController.prototype.onPostMessageReceived = function (e) {
        if (e.source === this.iframeElement.contentWindow && e.origin === this.tokenServerDomain) {
            this.removeBindings();

            try {
                var msg = JSON.parse(e.data);
                if (msg.state === PCI_STATUS_RESPONSES.OK) {

                    // If the IFrame is not visible, reject the rendering
                    // due to the height calculation limitation when the IFrame is not visible.
                    var isVisible = $(this.iframeElement).is(':visible');
                    if (!isVisible) {
                        this.setState(this.LPStateMaps.error, ERRORS.FORM_CALCULATION);
                        return;
                    }

                    this.setState(this.LPStateMaps.success);
                    var wrapper = this.getFirstElement(this.LPViewMap.stateWrapper);
                    wrapper.style.height = calculateContainerHeight(this, msg.height) + 'px';
                    this.iframeElement.style.height = msg.height + 'px';
                    var mainDialog = lpTag.WebAgent.logicController.getMainDialogOfConversation(this.secureFormData.chatId, this.chatsRootModelPath); //since secure form has to be part of the main dialog
                    lpTag.WebAgent.secureFormsController.reportEvent({
                        command: lpSecureFormsController.EVENT_TYPES.VIEWED,
                        chatId: this.secureFormData.chatId,
                        dialogId: mainDialog && mainDialog.dialogId,
                        visitorId: this.secureFormData.visitorId,
                        args: {
                            uniqueId: this.secureFormData.uniqueId,
                            secureFormId: this.secureFormData.secureFormId,
                            secureFormName: this.secureFormData.secureFormName
                        }
                    });


                } else {
                    this.setState(this.LPStateMaps.error, ERRORS.PCI_GW_ERROR);
                }
            } catch (ex) {
                this.setState(this.LPStateMaps.error, ERRORS.PCI_GW_DATA_ERROR);
            }
        }


        function calculateContainerHeight(context, pciHeight) {
            var headerView = context.getFirstElement(context.LPViewMap.secureFormHeader);
            var iFrameHeight = pciHeight >= MIN_BUBBLE_HEIGHT ? pciHeight : MIN_BUBBLE_HEIGHT;
            var headerHeight = headerView.offsetHeight;
            return (iFrameHeight + headerHeight) - BUBBLE_PADDING;
        }
    };

    SecureFormChatBubbleViewController.prototype.initIFrameView = function () {
        if (!lpTag.WebAgent.secureFormsController.canViewSecureForm(this.secureFormUniqueId)) {
            this.setState(this.LPStateMaps.error);
            return;
        }

        this.setState(this.LPStateMaps.loading);

        var self = this;
        var siteId = this.modelController.getModelParam('account');
        var formUuid = this.secureFormData.formUuid;
        var chatSessionId = this.secureFormData.chatSessiontId || this.secureFormData.chatId;

        // asserts:
        if (!this.tokenServerDomain) {
            logger.error('cannot get pci domain from csds.');
            return;
        }

        if(this.asyncMessaging || lpTag.WebAgent.logicController.isEngagementAsyncMessaging(chatSessionId, this.chatsRootModelPath)) {
            lpTag.WebAgent.secureFormsController.requestMessagingOTK({
                dialogId: this.secureFormData.chatId,
                submissionId: this.secureFormData.formUuid,
                invitationId: this.secureFormData.uniqueId,
                success: onSuccess,
                error: onError
            });
        }
        else {
            lpTag.WebAgent.secureFormsController.requestOTK({
                chatId: this.secureFormData.chatId,
                uuid: this.secureFormData.formUuid,
                success: onSuccess,
                error: onError
            });
        }

        function onError() {
            self.setState(self.LPStateMaps.error, 'request otk failed.');
        }

        function onSuccess (data) {
            if (formUuid) {
                formUuid = formUuid.replace(/&#45;/g, "-");
            }
            var url = _getSecureFormUrl();
            self.setIFrame(url);

            function _getSecureFormUrl() {
                var urlParams = {
                    siteid: siteId,
                    otk: data.otk || data.body || data.token.readOtk,
                    token: formUuid
                };

                if(self.asyncMessaging || lpTag.WebAgent.logicController.isEngagementAsyncMessaging(chatSessionId, self.chatsRootModelPath)) {
                    if (lpTag.WebAgent.logicController.isActiveChat(self.secureFormData.chatId)) {
                        urlParams.otkJson = siteId + ":" + self.secureFormData.uniqueId;
                    }
                    else {
                        urlParams.otkJson = JSON.stringify([{
                            key: "convId",
                            value: self.secureFormData.chatId
                        }]);
                    }
                }
                else {
                    if (lpTag.WebAgent.logicController.isActiveChat(self.secureFormData.chatId)) {
                        urlParams.otkJson = JSON.stringify({
                            siteId: siteId,
                            chatId: chatSessionId
                        });
                    } else {
                        urlParams.otkJson = JSON.stringify([{
                            key: "engId",
                            value: "" + self.secureFormData.chatId
                        }]);
                    }
                }
                return _addParamsToUrl(self.tokenServerDomain + PCI_RESULTS_PAGE, urlParams);
            }

            function _addParamsToUrl(url, params) {
                var paramsStr = "";
                for (var key in params) {
                    if (params.hasOwnProperty(key)) {
                        if (paramsStr !== "") {
                            paramsStr += "&";
                        }
                        paramsStr += key + "=" + encodeURIComponent(params[key]);
                    }
                }
                return url + "?" + paramsStr;
            }
        }

    };

    SecureFormChatBubbleViewController.prototype.setIFrame = function (url) {
        // setting the loading state.
        this.setState(this.LPStateMaps.loading);
        this.setBindings();

        // setting the 'SRC' attribute for the iframe element to trigger the loading.
        this.iframeElement.setAttribute('src', url);
        this.removeTimeout();
        this.iframeLoadingTimeout = setTimeout(this.onIFrameTimeOut, LOADING_TIMEOUT);
    };

    function _onIFrameLoaded() {
        this.setState(this.LPStateMaps.success);
    }

    function _onIFrameError() {
        this.setState(this.LPStateMaps.error, 'error when loading the IFrame.');
        this.removeTimeout();
    }

    function _onIFrameTimeOut() {
        this.setState(this.LPStateMaps.error, 'IFrame loading timed out.');
        this.iframeLoadingTimeout = null;

        // removing the listener to remove the response of the IFrame.
        // resetting the IFrame src.
        this.removeBindings();
        this.iframeElement.setAttribute('src', 'about:blank');
    }

    function _getSourceOrigin() {
        return (agentLEManager.getLEUrlResolverGetUrl(TOKENIZER_DOMAIN_KEY)).toLowerCase();
    }


    return SecureFormChatBubbleViewController;

});
